import React, { useRef, useState } from 'react';
import ButtonWithLoading from '../common/ButtomWIthLoading';
import { isReferenceNumberValid } from '../../utils/validations';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { generateRandomId } from '../../utils/global.utils';
import { ADD_EVENT, DELETE_LAST_EVENT } from '../../redux/reducers/eventReducer';
import { zenworksServiceApi } from '../../service/zenworksService.api';

const INITIAL_STATE = {
  referenceNumber: ''
}

const ReferencenumberCard: React.FC = () => {

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(INITIAL_STATE);
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  const dispatch = useDispatch<AppDispatch>();
  const isSubmittedRef = useRef(false);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const { isValid, message } = isReferenceNumberValid(value)

    if (!isValid && message) {
      setError(message);
    } else {
      setError("")
    }
    setFormValues({ referenceNumber: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault();
    const { isValid } = isReferenceNumberValid(formValues.referenceNumber)

    if (!isValid) {
      return;
    }
    setIsLoading(true);

    const divId = generateRandomId();
    isSubmittedRef.current = true;
    dispatch({
      type: ADD_EVENT,
      payload: {
        type: 'messageCard',
        id: divId,
        divId,
        user: 'actionCard',
        msg: 'Processing your request...',
        senderType: 'chatBot',
      },
    });
    try {
      const result = await zenworksServiceApi.getSubmissionStatusFromRefNo(formValues.referenceNumber);


      dispatch({
        type: DELETE_LAST_EVENT,
        payload: {},
      });

      dispatch({
        type: ADD_EVENT,
        payload: {
          type: 'messageCard',
          id: generateRandomId(),
          user: 'actionCard',
          msg: result.status === 200 ? result.message : "Invalid reference number",
          senderType: 'chatBot',
        },
      });

    } catch (error) {
      dispatch({
        type: DELETE_LAST_EVENT,
        payload: {},
      });

      dispatch({
        type: ADD_EVENT,
        payload: {
          type: 'messageCard',
          id: generateRandomId(),
          user: 'actionCard',
          msg: 'Error submitting reference number. Please try again.',
          senderType: 'chatBot',
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-lg shadow-md">
      <form onSubmit={handleSubmit}>

        <label htmlFor='referenceNumber' className='mb-2 text-gray-700 text-left font-medium text-sm'>
          Provide your Reference number for Submission Status. 
          <span className="text-red-500">*</span>
        </label>
        <input
          readOnly={isSubmittedRef.current}
          type="number"
          value={formValues.referenceNumber}
          name="referenceNumber"
          onChange={handleChange}
          placeholder="Enter your reference number"
          className="w-full p-2 border rounded no-arrows"
          inputMode="numeric"
          style={{ appearance: 'none', MozAppearance: 'textfield', WebkitAppearance: 'none', outline: 'none' }}
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        <div className="text-right">
          <ButtonWithLoading
            isLoading={isLoading}
            label="Submit"
            type="submit"
            className={`bg-[#114175] text-white p-2 rounded-lg w-full mt-4 disabled:bg-gray-400 ${connectionStatus !== 'Disconnected'
              ? 'hover:bg-[#6491C3]'
              : 'cursor-not-allowed opacity-50'
              }`}
            disabled={connectionStatus !== 'Connected' || isSubmittedRef.current || formValues.referenceNumber.length != 9}
          />
        </div>
      </form>
    </div>
  );
};

export default ReferencenumberCard;

